import type { Site } from 'site/types';

export function prependLocale(
  path: string,
  site: Pick<Site, 'locale' | 'countryInPath'>
): string {
  const locale = __LOCALE__;

  if (locale === site.locale || site.countryInPath !== null) {
    return path;
  } else {
    return ['/', locale, path].join('');
  }
}
